(function () {
	'use strict';

	angular
        .module('app')
        .factory('SystemService', SystemService);

	SystemService.$inject = [
        'DataService',
        'UrlService',
        '$q',
        '$http',
	    '$filter',
	    'ChilliUserProfileService'];

	function SystemService(
        DataService,
        UrlService,
        $q,
        $http,
        $filter,
        ChilliUserProfileService) {
	    var configDataService = DataService('systemconfig');
	    var systemConfig = null;

		var service = {
		    getMenuListSize: getMenuListSize,
		    getMergeFieldPrefix: getMergeFieldPrefix,
		    getMergeFieldSuffix: getMergeFieldSuffix,
		    getChilliDocsIcon: getChilliDocsIcon,
		    getFileIcon: getFileIcon,
		    getSVGIconList: getSVGIconList,
            getFileConversionFormats: getFileConversionFormats,
            getEntityTypeLink: getEntityTypeLink,
            getSearchDelay: getSearchDelay,
            getEntityTypesRequiringAdminAccess: getEntityTypesRequiringAdminAccess,
            getCommunicationSetting: getCommunicationSetting,
            saveCommunicationSetting: saveCommunicationSetting,
            getFormattedDate: getFormattedDate,
            getSystemMenuOptions: getSystemMenuOptions
		};

		var menuListSize = 10;
		var searchDelay = 500;

		return service;

		function getSearchDelay() {
		    return searchDelay;
		}

		function getMenuListSize(menuName) {
		    return $q.when(menuListSize);
		}

		function getEntityTypeLink(entityType) {
		    return $http.get(UrlService.getWebAPIUrl() + '/entitytype/' + entityType + '/Link/').then(
                function ok(response) {
                    return response.data;
                },
                function error(response) { return $q.reject(response); });
		}

		function getMergeFieldPrefix() {
		    return '[[ChilliDocs:';
		}

		function getMergeFieldSuffix() {
		    return ']]';
		}

		function getFileConversionFormats() {
		    var fileConversionFormats = {
		        txt: ['Txt'],
		        html: ['Html', 'Docx', 'Pdf'],
		        doc: ['Docx', 'Pdf'],
		        docx: ['Docx', 'Pdf'],
                pdf: ['Pdf']
		    };

		    return $q.when(fileConversionFormats);
		}

	    /*
         * Get the icon for a specific ChilliDocs usage, e.g. 'email' or 'document template'.
         *
         * @param {string} usage - Where the icon is being used determines which icon to return. E.g. 'email' or 'document template'.
         *
         * @returns {object} Returns an object which can contain 'icon' and 'iconColour' properties.
         */
		function getChilliDocsIcon(usage) {
		    var result = {};

		    if (_.isNil(usage)) {
		        return result;
		    }

		    switch (usage.toLowerCase()) {
		        case 'add':
		            result.icon = 'plus-box';
		            break;
		        case 'align bottom':
		            result.icon = 'format-vertical-align-bottom';
		            break;
		        case 'align left':
		            result.icon = 'format-horizontal-align-left';
		            break;
		        case 'align right':
		            result.icon = 'format-horizontal-align-right';
		            break;
		        case 'align top':
		            result.icon = 'format-vertical-align-top';
		            break;
		        case 'arrow right':
		            result.icon = 'arrow-right';
		            break;
		        case 'arrow down':
                    result.icon = 'arrow-down';
                    break;
		        case 'attachment':
		            result.icon = 'paperclip';
		            break;
		        case 'block':
		            result.icon = 'lock';
		            break;
		        case 'bold':
		            result.icon = 'format-bold';
		            break;
		        case 'checked':
		            result.icon = 'checkbox-marked';
		            break;
		        case 'chevron double left':
		            result.icon = 'chevron-double-left';
                    break;
		        case 'chevron double right':
		            result.icon = 'chevron-double-right';
                    break;
		        case 'chevron down':
		            result.icon = 'chevron-down';
		            break;
                case 'chevron left':
                    result.icon = 'chevron-left';
                    break;
		        case 'chevron right':
		            result.icon = 'chevron-right';
		            break;
		        case 'chevron up':
		            result.icon = 'chevron-up';
		            break;
		        case 'close':
		            result.icon = 'close';
		            break;
		        case 'collapse':
                    result.icon = 'minus-box';
		            break;
		        case 'communication setting':
		            result.icon = 'radio-tower';
		            break;
		        case 'copy':
		            result.icon = 'content-copy';
		            break;
		        case 'cursor':
		            result.icon = 'cursor-default';
		            break;
		        case 'cut':
		            result.icon = 'content-cut';
		            break;
		        case 'home':
                    result.icon = 'home';
                    break;
		        case 'delete':
		            result.icon = 'delete-forever';
		            break;
                case 'document template':
                    result = getFileIcon('docx');
                    break;
		        case 'download':
		            result.icon = 'download';
		            break;
		        case 'draft':
		            result.icon = 'lead-pencil';
		            break;
		        case 'edit':
		            result.icon = 'pencil';
		            break;
		        case 'email':
		        case 'email address':
                case 'email address cache':
		            result = getFileIcon('email');
		            break;
		        case 'email-draft':
		            result.icon = 'email-open';
		            result.iconColour = 'rgb(234,194,130)';
		            break;
		        case 'email multiple':
		            result.icon = 'email-multiple';
		            result.iconColour = 'rgb(234,194,130)';
		            break;
		        case 'email-sent':
		            result.icon = 'email-sent';
		            break;
		        case 'email-received':
		            result.icon = 'email-received';
		            break;
		        case 'email template':
		            result.icon = 'email-outline';
		            result.iconColour = 'rgb(234,194,130)';
		            break;
		        case 'entity':
                case 'entity template':
                    result.icon = 'folder-multiple';
                    result.iconColour = 'rgb(224,31,41)';
		            break;
		        case 'error':
		            result.icon = 'alert';
		            result.iconColour = 'rgb(230,50,20)';
		            break;
		        case 'expand':
		            result.icon = 'library-plus';
		            break;
		        case 'export':
		            result.icon = 'export';
		            break;
		        case 'file':
		            result.icon = 'file';
		            break;
		        case 'fullscreen':
		            result.icon = 'fullscreen';
		            break;
		        case 'help':
                    result.icon = 'help-circle';
                    break;
		        case 'history':
		            result.icon = 'history';
		            break;
		        case 'image':
		            result.icon = 'panorama';
		            break;
		        case 'import':
		            result.icon = 'import';
		            break;
		        case 'information':
		            result.icon = 'information-outline';
		            break;
		        case 'italic':
		            result.icon = 'format-italic';
		            break;
		        case 'item separator':
		            result.icon = 'arrow-right';
		            break;
		        case 'letter':
		            result.icon = 'truck-delivery';
		            break;
		        case 'link':
		            result.icon = 'link-variant';
		            break;
		        case 'merge':
		            result = getFileIcon('docx');
		            break;
		        case 'note':
		            result.icon = 'note';
		            result.iconColour = 'rgb(255,214,35)';
		            break;
                case 'notification':
                    result.icon = 'bell';
                    result.iconColour = 'rgb(48,95,163)';
                    break;
		        case 'organisation setting':
		            result.icon = 'domain';
		            break;
		        case 'paste':
		            result.icon = 'content-paste';
		            break;
		        case 'preview':
		            result.icon = 'eye';
		            break;
		        case 'print':
		            result.icon = 'printer';
		            break;
		        case 'properties':
		            result.icon = 'dots-horizontal';
		            break;
		        case 'publish':
		            result = getFileIcon('pdf');
		            break;
		        case 'received':
		            result.icon = 'arrow-left';
		            break;
		        case 'recipients':
		            result.icon = 'account-multiple-outline';
		            break;
		        case 'recycle':
		            result.icon = 'delete';
		            break;
		        case 'repeat':
		            result.icon = 'repeat';
		            break;
		        case 'restore':
		            result.icon = 'undo-variant';
		            break;
		        case 'retry':
		            result.icon = 'refresh';
		            break;
		        case 'run':
		            result.icon = 'play';
		            break;
		        case 'search':
		            result.icon = 'magnify';
		            break;
		        case 'select all':
		            result.icon = 'select-all';
		            break;
		        case 'selected':
		            result.icon = 'check';
		            break;
		        case 'sent':
		            result.icon = 'arrow-right';
		            break;
		        case 'setting':
		            result.icon = 'settings';
		            break;
		        case 'sms':
		            result = getFileIcon('sms');
		            break;
		        case 'sms multiple':
		            result.icon = 'comment-text-multiple';
		            result.iconColour = 'rgb(40,174,4)';
		            break;
		        case 'sms template':
		            result.icon = 'comment-text-outline';
		            result.iconColour = 'rgb(40,174,4)';
		            break;
		        case 'system setting other':
		            result.icon = 'basket';
		            break;
		        case 'tag':
		            result.icon = 'tag';
		            result.iconColour = 'rgb(165,42,42)';
		            break;
		        case 'task':
		            result.icon = 'format-list-bulleted';
		            result.iconColour = 'rgb(81,38,153)';
		            break;
		        case 'test merge':
		            result.icon = 'eye';
		            break;
		        case 'textbox':
		            result.icon = 'textbox';
		            break;
		        case 'unblock':
		            result.icon = 'lock-open';
		            break;
		        case 'unchecked':
		            result.icon = 'checkbox-blank-outline';
		            break;
		        case 'usage':
		            result.icon = 'chart-arc';
		            break;
		        case 'user':
		            if (!_.isNil(ChilliUserProfileService) && !_.isNil(ChilliUserProfileService.userProfile)) {
		                result.icon = ChilliUserProfileService.userProfile.EntityTemplate.Icon;
		                result.iconColour = ChilliUserProfileService.userProfile.EntityTemplate.IconColour;
		            }
                    break;
                case 'workflow':
                    result.icon = 'source-branch';
                    result.iconColour = 'rgb(37,128,0)';
                    break;
		        case 'workflow step default':
		            result.icon = 'checkbox-blank-circle-outline';
                    break;
		        case 'workflow step processed':
		            result.icon = 'check-circle-outline';
		            break;
		        case 'workflow step waiting':
		            result.icon = 'help-circle';
		            break;
		        case 'zoom in':
		            result.icon = 'magnify-plus';
		            break;
		        case 'zoom out':
		            result.icon = 'magnify-minus';
		            break;
		        case 'go up level':
		            result.icon = 'step-backward';
		            break;
		        case 'go down level':
		            result.icon = 'step-forward';
		            break;
		    }

		    return result;
		}

		function getFileIcon(extension) {
		    var result = { icon: 'file' };

		    if (_.isNil(extension)) {
		        return result;
		    }

		    switch (extension.toLowerCase()) {
		        case 'docx':
		        case 'doc':
		        case 'dot':
		        case 'dotx':
                case 'docm':
		            result.icon = 'file-word';
		            result.iconColour = 'rgb(41,85,152)';
		            break;

		        case 'task':
		            result.icon = 'format-list-bulleted';
		            break;

		        case 'txt':
		        case 'rtf':
		            result.icon = 'file-document';
		            result.iconColour = 'rgb(228,117,91)';
		            break;

		        case 'xls':
		        case 'xlsx':
		        case 'xlsb':
		        case 'xlsm':
                case 'csv':
		            result.icon = 'file-excel';
		            result.iconColour = 'rgb(31,114,70)';
		            break;

		        case 'pdf':
		            result.icon = 'file-pdf';
		            result.iconColour = 'rgb(228,30,0)';
		            break;

		        case 'ppt':
		        case 'pptx':
		        case 'pptm':
		        case 'ppsm':
		        case 'ppsx':
		        case 'potx':
		        case 'pps':
		        case 'pot':
		        case 'ppam':
		            result.icon = 'file-powerpoint';
		            result.iconColour = 'rgb(208,70,38)';
		            break;

		        case 'tif':
		        case 'tiff':
		        case 'gif':
		        case 'jpeg':
		        case 'jpg':
		        case 'png':
		        case 'bmp':
		            result.icon = 'file-image';
		            result.iconColour = 'rgb(0,255,127)';
		            break;

		        case 'msg':
		        case 'mime':
		        case 'email':
		        case 'eml':
		            result.icon = 'email';
		            result.iconColour = 'rgb(234,194,130)';
		            break;

		        case 'sms':
		            result.icon = 'comment-text';
		            result.iconColour = 'rgb(40,174,4)';
		            break;

		        case 'mkv':
		        case 'flv':
		        case 'vob':
		        case 'gif':
		        case 'avi':
		        case 'mov':
		        case 'wmv':
		        case 'amv':
		        case 'mp4':
		        case 'm4p':
		        case 'm4v':
		        case 'mpg':
		        case 'mpeg':
		            result.icon = 'file-video';
		            result.iconColour = 'rgb(128,0,128)';
		            break;

		        case 'aac':
		        case 'flac':
		        case 'gsm':
		        case 'm4a':
		        case 'm4b':
		        case 'm4p':
		        case 'mp3':
		        case 'ogg':
		        case 'oga':
		        case 'raw':
		        case 'wav':
		            result.icon = 'file-music';
		            result.iconColour = 'rgb(135,206,250)';
		            break;
		    }

		    return result;
		}

	    /*
         * Get a list of SVG icons that can be used within ChilliDocs
         *
         * @returns {array} Array of {string}
         */
		function getSVGIconList() {
            return ["access-point","access-point-network","account","account-alert","account-box","account-box-outline","account-card-details","account-check","account-circle","account-convert","account-key","account-location","account-minus","account-multiple","account-multiple-minus","account-multiple-outline","account-multiple-plus","account-network","account-off","account-outline","account-plus","account-remove","account-search","account-settings","account-settings-variant","account-star","account-star-variant","account-switch","adjust","air-conditioner","airballoon","airplane","airplane-landing","airplane-off","airplane-takeoff","airplay","alarm","alarm-check","alarm-multiple","alarm-off","alarm-plus","album","alert","alert-box","alert-circle","alert-circle-outline","alert-octagon","alert-outline","alpha","alphabetical","altimeter","amazon","amazon-clouddrive","ambulance","amplifier","anchor","android","android-debug-bridge","android-studio","animation","apple","apple-finder","apple-ios","apple-keyboard-caps","apple-keyboard-command","apple-keyboard-control","apple-keyboard-option","apple-keyboard-shift","apple-mobileme","apple-safari","application","apps","archive","arrange-bring-forward","arrange-bring-to-front","arrange-send-backward","arrange-send-to-back","arrow-all","arrow-bottom-left","arrow-bottom-right","arrow-compress","arrow-compress-all","arrow-down","arrow-down-bold","arrow-down-bold-circle","arrow-down-bold-circle-outline","arrow-down-bold-hexagon-outline","arrow-down-drop-circle","arrow-down-drop-circle-outline","arrow-expand","arrow-expand-all","arrow-left","arrow-left-bold","arrow-left-bold-circle","arrow-left-bold-circle-outline","arrow-left-bold-hexagon-outline","arrow-left-drop-circle","arrow-left-drop-circle-outline","arrow-right","arrow-right-bold","arrow-right-bold-circle","arrow-right-bold-circle-outline","arrow-right-bold-hexagon-outline","arrow-right-drop-circle","arrow-right-drop-circle-outline","arrow-top-left","arrow-top-right","arrow-up","arrow-up-bold","arrow-up-bold-circle","arrow-up-bold-circle-outline","arrow-up-bold-hexagon-outline","arrow-up-drop-circle","arrow-up-drop-circle-outline","assistant","at","attachment","audiobook","auto-fix","auto-upload","autorenew","av-timer","baby","backburger","backspace","backup-restore","bandcamp","bank","barcode","barcode-scan","barley","barrel","basecamp","basket","basket-fill","basket-unfill","battery","battery-10","battery-20","battery-30","battery-40","battery-50","battery-60","battery-70","battery-80","battery-90","battery-alert","battery-charging","battery-charging-100","battery-charging-20","battery-charging-30","battery-charging-40","battery-charging-60","battery-charging-80","battery-charging-90","battery-minus","battery-negative","battery-outline","battery-plus","battery-positive","battery-unknown","beach","beats","beer","behance","bell","bell-off","bell-outline","bell-plus","bell-ring","bell-ring-outline","bell-sleep","beta","bible","bike","bing","binoculars","bio","biohazard","bitbucket","black-mesa","blackberry","blender","blinds","block-helper","blogger","bluetooth","bluetooth-audio","bluetooth-connect","bluetooth-off","bluetooth-settings","bluetooth-transfer","blur","blur-linear","blur-off","blur-radial","bone","book","book-minus","book-multiple","book-multiple-variant","book-open","book-open-page-variant","book-open-variant","book-plus","book-variant","bookmark","bookmark-check","bookmark-music","bookmark-outline","bookmark-plus","bookmark-plus-outline","bookmark-remove","boombox","border-all","border-bottom","border-color","border-horizontal","border-inside","border-left","border-none","border-outside","border-right","border-style","border-top","border-vertical","bow-tie","bowl","bowling","box","box-cutter","box-shadow","bridge","briefcase","briefcase-check","briefcase-download","briefcase-upload","brightness-1","brightness-2","brightness-3","brightness-4","brightness-5","brightness-6","brightness-7","brightness-auto","broom","brush","buffer","bug","bulletin-board","bullhorn","bullseye","burst-mode","bus","cached","cake","cake-layered","cake-variant","calculator","calendar","calendar-blank","calendar-check","calendar-clock","calendar-multiple","calendar-multiple-check","calendar-plus","calendar-range","calendar-remove","calendar-text","calendar-today","call-made","call-merge","call-missed","call-received","call-split","camcorder","camcorder-box","camcorder-box-off","camcorder-off","camera","camera-enhance","camera-front","camera-front-variant","camera-iris","camera-off","camera-party-mode","camera-rear","camera-rear-variant","camera-switch","camera-timer","candle","candycane","car","car-battery","car-connected","car-wash","cards","cards-outline","cards-playing-outline","carrot","cart","cart-off","cart-outline","cart-plus","case-sensitive-alt","cash","cash-100","cash-multiple","cash-usd","cast","cast-connected","castle","cat","cellphone","cellphone-android","cellphone-basic","cellphone-dock","cellphone-iphone","cellphone-link","cellphone-link-off","cellphone-settings","certificate","chair-school","chart-arc","chart-areaspline","chart-bar","chart-bubble","chart-gantt","chart-histogram","chart-line","chart-pie","chart-scatterplot-hexbin","chart-timeline","check","check-all","check-circle","check-circle-outline","checkbox-blank","checkbox-blank-circle","checkbox-blank-circle-outline","checkbox-blank-outline","checkbox-marked","checkbox-marked-circle","checkbox-marked-circle-outline","checkbox-marked-outline","checkbox-multiple-blank","checkbox-multiple-blank-circle","checkbox-multiple-blank-circle-outline","checkbox-multiple-blank-outline","checkbox-multiple-marked","checkbox-multiple-marked-circle","checkbox-multiple-marked-circle-outline","checkbox-multiple-marked-outline","checkerboard","chemical-weapon","chevron-double-down","chevron-double-left","chevron-double-right","chevron-double-up","chevron-down","chevron-left","chevron-right","chevron-up","chip","church","cisco-webex","city","clipboard","clipboard-account","clipboard-alert","clipboard-arrow-down","clipboard-arrow-left","clipboard-check","clipboard-outline","clipboard-text","clippy","clock","clock-alert","clock-end","clock-fast","clock-in","clock-out","clock-start","close","close-box","close-box-outline","close-circle","close-circle-outline","close-network","close-octagon","close-octagon-outline","closed-caption","cloud","cloud-check","cloud-circle","cloud-download","cloud-outline","cloud-outline-off","cloud-print","cloud-print-outline","cloud-sync","cloud-upload","code-array","code-braces","code-brackets","code-equal","code-greater-than","code-greater-than-or-equal","code-less-than","code-less-than-or-equal","code-not-equal","code-not-equal-variant","code-parentheses","code-string","code-tags","codepen","coffee","coffee-to-go","coin","collage","color-helper","comment","comment-account","comment-account-outline","comment-alert","comment-alert-outline","comment-check","comment-check-outline","comment-multiple-outline","comment-outline","comment-plus-outline","comment-processing","comment-processing-outline","comment-question-outline","comment-remove-outline","comment-text","comment-text-outline","compare","compass","compass-outline","console","contact-mail","content-copy","content-cut","content-duplicate","content-paste","content-save","content-save-all","content-save-settings","contrast","contrast-box","contrast-circle","cookie","copyright","counter","cow","creation","credit-card","credit-card-multiple","credit-card-off","credit-card-plus","credit-card-scan","crop","crop-free","crop-landscape","crop-portrait","crop-square","crosshairs","crosshairs-gps","crown","cube","cube-outline","cube-send","cube-unfolded","cup","cup-off","cup-water","currency-btc","currency-eur","currency-gbp","currency-inr","currency-ngn","currency-rub","currency-try","currency-usd","currency-usd-off","cursor-default","cursor-default-outline","cursor-move","cursor-pointer","cursor-text","database","database-minus","database-plus","debug-step-into","debug-step-out","debug-step-over","decimal-decrease","decimal-increase","delete","delete-forever","delete-sweep","delete-variant","delta","deskphone","desktop-mac","desktop-tower","details","deviantart","dialpad","diamond","dice-1","dice-2","dice-3","dice-4","dice-5","dice-6","dice-d20","dice-d4","dice-d6","dice-d8","dictionary","directions","directions-fork","discord","disk","disk-alert","disqus","disqus-outline","division","division-box","dns","domain","dots-horizontal","dots-vertical","download","drag","drag-horizontal","drag-vertical","drawing","drawing-box","dribbble","dribbble-box","drone","dropbox","drupal","duck","dumbbell","earth","earth-off","edge","eject","elevation-decline","elevation-rise","elevator","email","email-open","email-open-outline","email-outline","email-secure","email-variant","emoticon","emoticon-cool","emoticon-devil","emoticon-happy","emoticon-neutral","emoticon-poop","emoticon-sad","emoticon-tongue","engine","engine-outline","equal","equal-box","eraser","eraser-variant","escalator","ethernet","ethernet-cable","ethernet-cable-off","etsy","ev-station","evernote","exclamation","exit-to-app","export","eye","eye-off","eyedropper","eyedropper-variant","face","face-profile","facebook","facebook-box","facebook-messenger","factory","fan","fast-forward","fax","ferry","file","file-chart","file-check","file-cloud","file-delimited","file-document","file-document-box","file-excel","file-excel-box","file-export","file-find","file-hidden","file-image","file-import","file-lock","file-multiple","file-music","file-outline","file-pdf","file-pdf-box","file-powerpoint","file-powerpoint-box","file-presentation-box","file-restore","file-send","file-tree","file-video","file-word","file-word-box","file-xml","film","filmstrip","filmstrip-off","filter","filter-outline","filter-remove","filter-remove-outline","filter-variant","fingerprint","fire","firefox","fish","flag","flag-checkered","flag-outline","flag-outline-variant","flag-triangle","flag-variant","flash","flash-auto","flash-off","flash-red-eye","flashlight","flashlight-off","flask","flask-empty","flask-empty-outline","flask-outline","flattr","flip-to-back","flip-to-front","floppy","flower","folder","folder-account","folder-download","folder-google-drive","folder-image","folder-lock","folder-lock-open","folder-move","folder-multiple","folder-multiple-image","folder-multiple-outline","folder-outline","folder-plus","folder-remove","folder-upload","food","food-apple","food-fork-drink","food-off","food-variant","football","football-australian","football-helmet","format-align-center","format-align-justify","format-align-left","format-align-right","format-annotation-plus","format-bold","format-clear","format-color-fill","format-float-center","format-float-left","format-float-none","format-float-right","format-header-1","format-header-2","format-header-3","format-header-4","format-header-5","format-header-6","format-header-decrease","format-header-equal","format-header-increase","format-header-pound","format-horizontal-align-center","format-horizontal-align-left","format-horizontal-align-right","format-indent-decrease","format-indent-increase","format-italic","format-line-spacing","format-line-style","format-line-weight","format-list-bulleted","format-list-bulleted-type","format-list-numbers","format-paint","format-paragraph","format-quote","format-size","format-strikethrough","format-strikethrough-variant","format-subscript","format-superscript","format-text","format-textdirection-l-to-r","format-textdirection-r-to-l","format-title","format-underline","format-vertical-align-bottom","format-vertical-align-center","format-vertical-align-top","format-wrap-inline","format-wrap-square","format-wrap-tight","format-wrap-top-bottom","forum","forward","foursquare","fridge","fridge-filled","fridge-filled-bottom","fridge-filled-top","fullscreen","fullscreen-exit","function","gamepad","gamepad-variant","gas-cylinder","gas-station","gate","gauge","gavel","gender-female","gender-male","gender-male-female","gender-transgender","ghost","gift","git","github-box","github-circle","glass-flute","glass-mug","glass-stange","glass-tulip","glassdoor","glasses","gmail","gnome","google","google-cardboard","google-chrome","google-circles","google-circles-communities","google-circles-extended","google-circles-group","google-controller","google-controller-off","google-drive","google-earth","google-glass","google-maps","google-nearby","google-pages","google-physical-web","google-play","google-plus","google-plus-box","google-translate","google-wallet","grease-pencil","grid","grid-off","group","guitar-electric","guitar-pick","guitar-pick-outline","hackernews","hand-pointing-right","hanger","hangouts","harddisk","headphones","headphones-box","headphones-settings","headset","headset-dock","headset-off","heart","heart-box","heart-box-outline","heart-broken","heart-outline","heart-pulse","help","help-circle","help-circle-outline","hexagon","hexagon-outline","highway","history","hololens","home","home-map-marker","home-modern","home-variant","hops","hospital","hospital-building","hospital-marker","hotel","houzz","houzz-box","human","human-child","human-female","human-greeting","human-handsdown","human-handsup","human-male","human-male-female","human-pregnant","image","image-album","image-area","image-area-close","image-broken","image-broken-variant","image-filter","image-filter-black-white","image-filter-center-focus","image-filter-center-focus-weak","image-filter-drama","image-filter-frames","image-filter-hdr","image-filter-none","image-filter-tilt-shift","image-filter-vintage","image-multiple","import","inbox","incognito","information","information-outline","information-variant","instagram","instapaper","internet-explorer","invert-colors","itunes","jeepney","jira","jsfiddle","json","keg","kettle","key","key-change","key-minus","key-plus","key-remove","key-variant","keyboard","keyboard-backspace","keyboard-caps","keyboard-close","keyboard-off","keyboard-return","keyboard-tab","keyboard-variant","kodi","label","label-outline","lambda","lan","lan-connect","lan-disconnect","lan-pending","language-c","language-cpp","language-csharp","language-css3","language-html5","language-javascript","language-php","language-python","language-python-text","laptop","laptop-chromebook","laptop-mac","laptop-windows","lastfm","launch","layers","layers-off","lead-pencil","leaf","led-off","led-on","led-outline","led-variant-off","led-variant-on","led-variant-outline","library","library-books","library-music","library-plus","lightbulb","lightbulb-outline","link","link-off","link-variant","link-variant-off","linkedin","linkedin-box","linux","lock","lock-open","lock-open-outline","lock-outline","lock-plus","login","login-variant","logout","logout-variant","looks","loupe","lumx","magnet","magnet-on","magnify","magnify-minus","magnify-plus","mail-ru","map","map-marker","map-marker-circle","map-marker-minus","map-marker-multiple","map-marker-off","map-marker-plus","map-marker-radius","margin","markdown","marker","marker-check","martini","material-ui","math-compass","matrix","maxcdn","medium","memory","menu","menu-down","menu-left","menu-right","menu-up","message","message-alert","message-draw","message-image","message-outline","message-plus","message-processing","message-reply","message-reply-text","message-text","message-text-outline","message-video","meteor","microphone","microphone-off","microphone-outline","microphone-settings","microphone-variant","microphone-variant-off","microscope","microsoft","minecraft","minus","minus-box","minus-circle","minus-circle-outline","minus-network","mixcloud","monitor","monitor-multiple","more","motorbike","mouse","mouse-off","mouse-variant","mouse-variant-off","move-resize","move-resize-variant","movie","multiplication","multiplication-box","music-box","music-box-outline","music-circle","music-note","music-note-bluetooth","music-note-bluetooth-off","music-note-eighth","music-note-half","music-note-off","music-note-quarter","music-note-sixteenth","music-note-whole","nature","nature-people","navigation","near-me","needle","nest-protect","nest-thermostat","new-box","newspaper","nfc","nfc-tap","nfc-variant","nodejs","note","note-outline","note-plus","note-plus-outline","note-text","notification-clear-all","numeric","numeric-0-box","numeric-0-box-multiple-outline","numeric-0-box-outline","numeric-1-box","numeric-1-box-multiple-outline","numeric-1-box-outline","numeric-2-box","numeric-2-box-multiple-outline","numeric-2-box-outline","numeric-3-box","numeric-3-box-multiple-outline","numeric-3-box-outline","numeric-4-box","numeric-4-box-multiple-outline","numeric-4-box-outline","numeric-5-box","numeric-5-box-multiple-outline","numeric-5-box-outline","numeric-6-box","numeric-6-box-multiple-outline","numeric-6-box-outline","numeric-7-box","numeric-7-box-multiple-outline","numeric-7-box-outline","numeric-8-box","numeric-8-box-multiple-outline","numeric-8-box-outline","numeric-9-box","numeric-9-box-multiple-outline","numeric-9-box-outline","numeric-9-plus-box","numeric-9-plus-box-multiple-outline","numeric-9-plus-box-outline","nutrition","oar","octagon","octagon-outline","odnoklassniki","office","oil","oil-temperature","omega","onedrive","opacity","open-in-app","open-in-new","openid","opera","ornament","ornament-variant","owl","package","package-down","package-up","package-variant","package-variant-closed","page-first","page-last","palette","palette-advanced","panda","pandora","panorama","panorama-fisheye","panorama-horizontal","panorama-vertical","panorama-wide-angle","paper-cut-vertical","paperclip","parking","pause","pause-circle","pause-circle-outline","pause-octagon","pause-octagon-outline","paw","paw-off","pen","pencil","pencil-box","pencil-box-outline","pencil-lock","pencil-off","percent","pharmacy","phone","phone-bluetooth","phone-classic","phone-forward","phone-hangup","phone-in-talk","phone-incoming","phone-locked","phone-log","phone-minus","phone-missed","phone-outgoing","phone-paused","phone-plus","phone-settings","phone-voip","pi","pi-box","piano","pig","pill","pin","pin-off","pine-tree","pine-tree-box","pinterest","pinterest-box","pizza","play","play-box-outline","play-circle","play-circle-outline","play-pause","play-protected-content","playlist-check","playlist-minus","playlist-play","playlist-plus","playlist-remove","playstation","plus","plus-box","plus-circle","plus-circle-multiple-outline","plus-circle-outline","plus-network","plus-one","pocket","pokeball","polaroid","poll","poll-box","polymer","pool","popcorn","pot","pot-mix","pound","pound-box","power","power-settings","power-socket","presentation","presentation-play","printer","printer-3d","printer-alert","priority-high","priority-low","professional-hexagon","projector","projector-screen","pulse","puzzle","qqchat","qrcode","qrcode-scan","quadcopter","quality-high","quicktime","radar","radiator","radio","radio-handheld","radio-tower","radioactive","radiobox-blank","radiobox-marked","raspberrypi","ray-end","ray-end-arrow","ray-start","ray-start-arrow","ray-start-end","ray-vertex","rdio","read","readability","receipt","record","record-rec","recycle","reddit","redo","redo-variant","refresh","regex","relative-scale","reload","remote","rename-box","repeat","repeat-off","repeat-once","replay","reply","reply-all","reproduction","resize-bottom-right","responsive","rewind","ribbon","road","road-variant","rocket","rotate-3d","rotate-left","rotate-left-variant","rotate-right","rotate-right-variant","rounded-corner","router-wireless","routes","rowing","rss","rss-box","ruler","run","sale","satellite","satellite-variant","saxophone","scale","scale-balance","scale-bathroom","school","screen-rotation","screen-rotation-lock","screwdriver","script","sd","seal","seat-flat","seat-flat-angled","seat-individual-suite","seat-legroom-extra","seat-legroom-normal","seat-legroom-reduced","seat-recline-extra","seat-recline-normal","security","security-network","select","select-all","select-inverse","select-off","selection","send","serial-port","server","server-minus","server-network","server-network-off","server-off","server-plus","server-remove","server-security","settings","settings-box","shape-circle-plus","shape-plus","shape-polygon-plus","shape-rectangle-plus","shape-square-plus","share","share-variant","shield","shield-outline","shopping","shopping-music","shredder","shuffle","shuffle-disabled","shuffle-variant","sigma","sigma-lower","sign-caution","signal","signal-variant","silverware","silverware-fork","silverware-spoon","silverware-variant","sim","sim-alert","sim-off","sitemap","skip-backward","skip-forward","skip-next","skip-next-circle","skip-next-circle-outline","skip-previous","skip-previous-circle","skip-previous-circle-outline","skype","skype-business","slack","sleep","sleep-off","smoking","smoking-off","snapchat","snowman","soccer","sofa","sort","sort-alphabetical","sort-ascending","sort-descending","sort-numeric","sort-variant","soundcloud","source-branch","source-fork","source-merge","source-pull","speaker","speaker-off","speedometer","spellcheck","spotify","spotlight","spotlight-beam","spray","square-inc","square-inc-cash","stackexchange","stackoverflow","stairs","star","star-circle","star-half","star-off","star-outline","steam","steering","step-backward","step-backward-2","step-forward","step-forward-2","stethoscope","sticker","stocking","stop","stop-circle","stop-circle-outline","store","store-24-hour","stove","subdirectory-arrow-left","subdirectory-arrow-right","subway","sunglasses","surround-sound","swap-horizontal","swap-vertical","swim","switch","sword","sync","sync-alert","sync-off","tab","tab-unselected","table","table-column-plus-after","table-column-plus-before","table-column-remove","table-column-width","table-edit","table-large","table-row-height","table-row-plus-after","table-row-plus-before","table-row-remove","tablet","tablet-android","tablet-ipad","tag","tag-faces","tag-multiple","tag-outline","tag-text-outline","target","taxi","teamviewer","telegram","television","television-guide","temperature-celsius","temperature-fahrenheit","temperature-kelvin","tennis","tent","terrain","test-tube","text-shadow","text-to-speech","text-to-speech-off","textbox","texture","theater","theme-light-dark","thermometer","thermometer-lines","thumb-down","thumb-down-outline","thumb-up","thumb-up-outline","thumbs-up-down","ticket","ticket-account","ticket-confirmation","tie","timelapse","timer","timer-10","timer-3","timer-off","timer-sand","timetable","toggle-switch","toggle-switch-off","tooltip","tooltip-edit","tooltip-image","tooltip-outline","tooltip-outline-plus","tooltip-text","tooth","tor","traffic-light","train","tram","transcribe","transcribe-close","transfer","translate","tree","trello","trending-down","trending-neutral","trending-up","triangle","triangle-outline","trophy","trophy-award","trophy-outline","trophy-variant","trophy-variant-outline","truck","truck-delivery","tshirt-crew","tshirt-v","tumblr","tumblr-reblog","tune","tune-vertical","twitch","twitter","twitter-box","twitter-circle","twitter-retweet","ubuntu","umbraco","umbrella","umbrella-outline","undo","undo-variant","unfold-less","unfold-more","ungroup","untappd","upload","usb","vector-arrange-above","vector-arrange-below","vector-circle","vector-circle-variant","vector-combine","vector-curve","vector-difference","vector-difference-ab","vector-difference-ba","vector-intersection","vector-line","vector-point","vector-polygon","vector-polyline","vector-rectangle","vector-selection","vector-square","vector-triangle","vector-union","verified","vibrate","video","video-off","video-switch","view-agenda","view-array","view-carousel","view-column","view-dashboard","view-day","view-grid","view-headline","view-list","view-module","view-quilt","view-stream","view-week","vimeo","vine","violin","visualstudio","vk","vk-box","vk-circle","vlc","voice","voicemail","volume-high","volume-low","volume-medium","volume-off","vpn","walk","wallet","wallet-giftcard","wallet-membership","wallet-travel","wan","watch","watch-export","watch-import","water","water-off","water-percent","water-pump","watermark","weather-cloudy","weather-fog","weather-hail","weather-lightning","weather-lightning-rainy","weather-night","weather-partlycloudy","weather-pouring","weather-rainy","weather-snowy","weather-snowy-rainy","weather-sunny","weather-sunset","weather-sunset-down","weather-sunset-up","weather-windy","weather-windy-variant","web","webcam","webhook","wechat","weight","weight-kilogram","whatsapp","wheelchair-accessibility","white-balance-auto","white-balance-incandescent","white-balance-iridescent","white-balance-sunny","wifi","wifi-off","wii","wikipedia","window-close","window-closed","window-maximize","window-minimize","window-open","window-restore","windows","wordpress","worker","wrap","wrench","wunderlist","xaml","xbox","xbox-controller","xbox-controller-off","xda","xing","xing-box","xing-circle","xml","yeast","yelp","yin-yang","youtube-play","zip-box"];
        }

	    /**
         * Get a list of the entity types that are read-only for non-admin users.
         *
         * @returns {array} Array of {string}
         */
		function getEntityTypesRequiringAdminAccess() {

		    // SEE ALSO: EntityMaintenance.UserCanEditEntity(..)

		    return [
		        'User',
                'Organisation',
                'Email Setting'
		    ];
		}

	    /**
         * GET the communication setting for the current tenancy.
         *
         */
		function getCommunicationSetting() {
		    var url = UrlService.getWebAPIUrl() + '/setting/communication/';

		    return $http.get(url)
                .then(function (response) {
                    return response.data;
                }, function (response) {
                    return $q.reject(response);
                });
		}

	    /**
         * PUT the communication setting for the current tenancy.
         *
         * If the communication setting has yet to be persisted, it will be added. Otherwise the current communication setting will be updated.
         *
         * @param {Object} communicationSetting - The communication setting to save.
         */
		function saveCommunicationSetting(communicationSetting) {
		    var url = UrlService.getWebAPIUrl() + '/setting/communication/';

		    return $http.put(url, communicationSetting)
                .then(function (response) {
                    return response.data;
                }, function (response) {
                    return $q.reject(response);
                });
		}

	    /**
         * Converts raw date string into a user friendly format
         *
         * @param {string} dateString - Unformatted UTC date string
         *
         * @returns {string} date formatted into a more readible form
         */
        function getFormattedDate(dateString) {
            // TODO: Due to lack of field formatting, $filter is being used to convert the date into a more readable string. Once proper formatting is introduced this code should be updated
            // to reflect the new functionality.
            var result = '';

            if (!_.isNil(dateString)) {
                result = $filter('date')(dateString, "longDate") + ' ' + $filter('date')(dateString, "shortTime");
            }

            return result;
        }

	    /*
         * Get the system menu options, seen at the #/system/setting route. This includes counts for options where applicable.
         */
        function getSystemMenuOptions() {
            return $http.get(UrlService.getWebAPIUrl() + '/systemmenuoptions').then(
                function ok(response) { return response.data; });
        }
	}
})();